var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-ss-c-filter-string",class:{ 'l-ss-c-filter-is-short': _vm.isShort }},[(_vm.showTitle)?_c('c-label',{attrs:{"label":_vm.filterLabel}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }